import { BaseWidget, WidgetCategory, WidgetDefinition } from './base.types';
import { DwQueryRequest, FieldType, SortBy } from './QueryObject.types';
import { ColumnFormatter, FieldStyleType } from './types';

export enum TableSubType {
  Table = 'TABLE',
  PivotTable = 'PIVOT_TABLE',
}

export const columnFormatterTypes: Record<ColumnFormatter, FieldType[]> = {
  [ColumnFormatter.Progress]: [FieldType.metric],
  [ColumnFormatter.None]: [FieldType.metric],
  [ColumnFormatter.SourceIcons]: [FieldType.dim],
  [ColumnFormatter.Text]: [FieldType.dim],
  [ColumnFormatter.SourceIconsWithNames]: [FieldType.dim],
  [ColumnFormatter.HeatMap]: [FieldType.metric],
};

export type TableCustomDefinition = {
  rowSize: TableRowSize;
  showTotals?: boolean;
  crossTableView?: boolean;
  fieldStyle?: Record<string, FieldStyleType>;
  applyFormattingToAll?: FieldStyleType;
  pageSize?: number;
  topN?: number;
};

export type TableWidget = BaseWidget & {
  category: WidgetCategory.Table;
  definition: WidgetDefinition & { custom: TableCustomDefinition };
};

export enum TableRowSize {
  Small = 'xSmall',
  Medium = 'small',
  Large = 'large',
  Tiles = 'tiles',
}

export type TableTypeWidget = TableWidget & {
  type: TableSubType.Table;
};

export type PivotTableRequest = DwQueryRequest & { sortingCol: SortBy[] };
export type PivotTableTypeWidget = Omit<TableWidget, 'requests'> & {
  type: TableSubType.PivotTable;
  requests: PivotTableRequest[];
  definition: WidgetDefinition & { custom: TableCustomDefinition & { showColTotals: boolean } };
};

export type TableCategoryWidgetTypes = TableTypeWidget | PivotTableTypeWidget;
